module.exports = __webpack_public_path__ + "static/play-next-70c85dde196599f5bb20274450d3407e.png";